import { createSelector } from 'reselect'

export const getNotifications = createSelector(
  (state) => state && state.notifications && state.notifications.list && state.notifications.list.elements ? state.notifications.list.elements : [],
  notifications => notifications
)
